<template>
	<v-card>
		<v-card-title>
			Azione in massa: Tag Pratica
		</v-card-title>
		
		<v-card-text>
			<v-row>
				<v-col>
					<v-form ref="formAggiungiTagPraticaInMassa">
						
						<v-autocomplete
							ref="newOrSelectedTagCombobox"
							v-model="selectedPraticaTag"
							:items="allPraticaTags"
							:loading="isLoadingAllPraticaTags"
							:disabled="isLoadingAllPraticaTags || syncInProgress"
							:search-input.sync="searchPraticaTag"
							autocomplete="nope"
							item-text="text"
							item-value="id"
							label="Tags"
							return-object
							outlined
							clearable
							dense
							class="mt-1"
							:rules="[mixin_rules.requiredObject]"
						></v-autocomplete>
						
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
		
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				class="black--text"
				@click="$emit('close')"
			>
				Chiudi
			</v-btn>
			<v-btn
				color="secondary"
				@click="assegnaInMassaTag()"
				:loading="isLoadingAggiuntaTagPraticaInMassa"
			>
				Esegui
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		praticheIds: {
			default: []
		}
	},
	data() {
		return {
			allPraticaTags: [],
			isLoadingAllPraticaTags: false,
			searchPraticaTag: null,
			
			selectedPraticaTag: null,
			isLoadingAggiuntaTagPraticaInMassa: false
		}
	},
	
	created() {
		this.getAllPraticaTags();
	},
	
	
	methods: {
		getAllPraticaTags() {
			this.isLoadingAllPraticaTags = true;
			axios.get(`/api/tags`, {
				params: {
					type: 'pratica'
				}
			})
				.then(response => {
					this.allPraticaTags = response.data;
				})
				.finally(() => {
					this.isLoadingAllPraticaTags = false;
				})
		},
		assegnaInMassaTag() {
			if (!this.$refs.formAggiungiTagPraticaInMassa.validate()) return;

			this.isLoadingAggiuntaTagPraticaInMassa = true;
			axios.post('/api/pratiche/assegna-in-massa-tag', {
				tag: this.selectedPraticaTag,
				pratiche_ids: this.praticheIds
			})
				.then(() => {
					this.$emit('close');
					this.$emit('done');
				})
				.finally(() => {
					this.isLoadingAggiuntaTagPraticaInMassa = false;
				})
		}
	}
}
</script>